import { Observable, forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';
import { InstructivoEmbarqueService } from '../../../services/instructivo-embarque.service';
import {
    AntecedentesCatalogsDto,
    ContainerPackageTypeDto,
    PalletPackageTypeDto,
    ColdTreatmentIndicatorDto,
    ControlledAtmosphereDto,
    VentilationUnitDto,
    SpeciesPackageTypeDto,
} from '@opb-workspace/shared';

export interface Step4CatalogSnapshot {
    catalogs: AntecedentesCatalogsDto;
    containerPackageTypes: ContainerPackageTypeDto[];
    palletPackageTypes: PalletPackageTypeDto[];
    coldTreatmentIndicators: ColdTreatmentIndicatorDto[];
    controlledAtmospheres: ControlledAtmosphereDto[];
    ventilationUnits: VentilationUnitDto[];
    speciesPackageTypes: SpeciesPackageTypeDto[];
}

export function loadStep4CatalogSnapshot(
    service: InstructivoEmbarqueService,
): Observable<Step4CatalogSnapshot> {
    return forkJoin({
        catalogs: service.getCatalogs(),
        containerTypes: service.getContainerPackageTypes(),
        palletTypes: service.getPalletPackageTypes(),
        coldTreatment: service.getColdTreatmentIndicators(),
        controlled: service.getControlledAtmospheres(),
        ventilation: service.getVentilationUnits(),
        speciesPkg: service.getSpeciesPackageTypes(),
    }).pipe(
        map((r) => ({
            catalogs: r.catalogs,
            containerPackageTypes: r.containerTypes,
            palletPackageTypes: r.palletTypes,
            coldTreatmentIndicators: r.coldTreatment,
            controlledAtmospheres: r.controlled,
            ventilationUnits: r.ventilation,
            speciesPackageTypes: r.speciesPkg,
        })),
    );
}
